import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/authContext"
import { subscribe, autoSubscribe, saveSubscription } from "../../services/notificationService.js";

export default function ButtonActivateNotification(){

    const {user} = useContext(AuthContext)
    const [permiso, setPermiso] = useState('default')
    console.log(user)

    useEffect(() => {
        if (!user) return

        const checkSubscription = async () => {
            const registration = await navigator.serviceWorker.ready
            const existingSub = await registration.pushManager.getSubscription()

            if (existingSub) {
                await saveSubscription(existingSub, user.id)
                setPermiso(Notification.permission)
                return
            }

            const tieneSub = await autoSubscribe(user.id)
            setPermiso(tieneSub ? Notification.permission : 'default')
        }
        checkSubscription()
    }, [user])

    const handleActivar = async () => {
        await subscribe(user.id)
        setPermiso(Notification.permission)
    }

    return(
        <div>
            {permiso === 'default' && (
                <button onClick={handleActivar}>
                🔔 Activar notificaciones
                </button>
            )}
            {permiso === 'granted' && (
                <p>✅ Notificaciones activadas</p>
            )}
            {permiso === 'denied' && (
                <p>❌ Bloqueaste las notificaciones. Actívalas desde la configuración del navegador.</p>
            )}
        </div>
    )
}